import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { IconContext } from 'react-icons';
import store from './store/store';
import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';
import 'reactflow/dist/style.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Layout from './views/Layout';
import Home from './views/page.Home';
import Item from './views/page.Item';
import Test from './views/page.Test';
import DocsUser from './views/page.DocsUser';
import Roadmap from './views/page.Roadmap';
import Templates from './views/page.Templates';
import Profile from './views/page.Profile';
import ResetPassword from './views/page.ResetPassword';
import E2EAppSmoke from './views/page.E2EAppSmoke';
import E2EBoardMap from './views/page.E2EBoardMap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <IconContext.Provider value={{ className: 'app-icon' }}>
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            element={<Layout />}
          >
            <Route
              index
              element={<Home />}
            />
            <Route
              index='/test'
              element={<Test />}
            />
            {/* <Route path='test' element={<Test />} /> */}
            <Route
              path='/item/:id'
              element={<Item />}
            />
            <Route
              path='/docs/user/*'
              element={<DocsUser />}
            />
            <Route
              path='/roadmap'
              element={<Roadmap />}
            />
            <Route
              path='/templates'
              element={<Templates />}
            />
            <Route
              path='/profile'
              element={<Profile />}
            />
            <Route
              path='/profil'
              element={<Profile />}
            />
            <Route
              path='/reset-password'
              element={<ResetPassword />}
            />
            {process.env.NODE_ENV !== 'production' && (
              <>
                <Route
                  path='/e2e/app-smoke'
                  element={<E2EAppSmoke />}
                />
                <Route
                  path='/e2e/board-map'
                  element={<E2EBoardMap />}
                />
              </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
    </IconContext.Provider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
